import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import bootstrap from 'bootstrap';
import Global from 'models/Global';
import AddToCalendarView from 'web-common/scripts/views/AddToCalendarView';
import Config from 'config';
import trackTemplate from 'hbars!templates/trackList';

var SessionCalendarView = Backbone.View.extend({

    events: {

    },

    initialize: function(options) {
        this.agenda = Global.get('agenda');
        this.me = Global.get('me');
        this.model.set('unique-name', Global.get('event').get('unique-name'));
        this.listenTo(this.model.get('tracks'), 'change:disabled', this.setVisibilty);
        this.listenTo(this.agenda, 'viewState', this.setVisibilty);
        this.setVisibilty();
    },

    setVisibilty: function() {
        var visibleTracks = this.model.hasVisibleTracks();
        this.model.set('isHidden', !visibleTracks);
        Backbone.trigger('renderCalendar');
        this.model.collection.trigger('visibilityChanged');

    },

    remove: function() {
        return Backbone.View.prototype.remove.call(this);
    },

    render: function() {
        this.$('.session-tracks-holder') && this.$('.session-tracks-holder').remove();
        var html = trackTemplate({tracks: this.model.get('tracks').toJSON()});
        $(html).prependTo(this.$('.fc-content'));
        this.$el.toggleClass('hide', this.model.get('isHidden'));
        this.$('.track-circle').tooltip({container: 'body'});
        return this;
    }

});

export default SessionCalendarView;


